import React, { useState, useEffect } from 'react';
import {
  Spin, Button, Card, Tooltip, Input, Modal, Space, Table
} from 'antd';
import {
  AppstoreOutlined
} from '@ant-design/icons';
import 'antd/dist/antd.css';
import Fuse from 'fuse.js';
import _ from 'lodash';
import moment from 'moment';
import * as Service from '../core/Service';
import NavAndSideFrame from '../components/NavAndSideFrame';
import FeedBackForm from '../components/FeedBackForm';
import { useTranslation } from 'react-i18next';

const title = `意見回饋列表`;
const selectedKey = `feedback_list`;
const tableIdName = `feedback_id`;
const filterableField = [
  'feedback_title',
  'feedback_content'
];
const defaultFormData = {
  feedback_title: undefined,
  feedback_content: undefined
}

const FeedBackList = (props) => {
  const {t} = useTranslation();

  const [dataList, setDataList] = useState([]);
  const [unChangeData, setUnChangeData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});
  // const [isShowPassword, setShowPassword] = useState(false);
  // const [isChangingIsActive, setChangingIsActive] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getAllData();
  }, []);

  const getAllData = async () => {
    let endpoint = `/api/feedback/list`;
    let list = [];
    setLoading(true);
    try {
      let data = await Service.call(`GET`, endpoint);
      list = _.orderBy(data, [`ctime`], [`desc`]);
      if (data.errorMessage) list = [];
    } catch (error) {
      console.log(error);
    } finally {
      setDataList(list);
      setUnChangeData(list);
      setLoading(false);
    }
  }

  const setTableHeader = () => {
    let columns = [
      {
        title: '操作',
        dataIndex: tableIdName,
        render: (value, record) => {
          return (
            <span>
              <Tooltip title={t('common.view')}>
                <Button
                  shape="circle"
                  style={{ marginRight: 8, color: '#000000' }}
                  icon={<AppstoreOutlined />}
                  onClick={() => {
                    setSelectedRecord(record);
                    setModalVisible(true);
                  }}
                />
              </Tooltip>
            </span>
          )
        }
      },
      { title: '意見編號', dataIndex: tableIdName },
      { title: `標題`, dataIndex: `feedback_title` },
      { title: `內容`, dataIndex: `feedback_content` },
      {
        title: '創建時間',
        dataIndex: 'ctime',
        render: (value) => {
          return displayMoment(value);
        },
        ellipsis: true,
      },
      {
        title: '更新時間',
        dataIndex: 'utime',
        render: (value) => {
          return displayMoment(value);
        },
        ellipsis: true,
      },

    ];
    return columns;
  }

  const displayMoment = (unixTime, outputFormat = 'YYYY/MM/DD HH:mm') => {
    if (unixTime !== 0) {
      let displayTime = moment.unix(unixTime).format(outputFormat);
      return displayTime;
    }
    return '-';
  }

  const getDataBySearchKeyword = (keywords) => {
    let dataList = [];
    try {
      const options = {
        includeScore: true,
        findAllMatches: true,
        threshold: 0.15,
        keys: filterableField
      }
      const fuse = new Fuse(unChangeData, options)
      const result = fuse.search(keywords);
      console.log("RESULT", result);
      dataList = _.map(result, 'item');
      dataList = _.orderBy(dataList, [`ctime`], [`desc`]);
    } catch (error) {
      console.error('error >>> ', error);
    } finally {
      setDataList(dataList);
    }
  }

  let timeout;
  const debounce = (func, delay) => {
    clearTimeout(timeout);
    timeout = setTimeout(func, delay);
  };

  const onChange = (keyword) => {
    debounce(() => {
      getDataBySearchKeyword(keyword);
      if (_.isEmpty(keyword)) setDataList(unChangeData);
    }, 400);
  };

  return (
    <NavAndSideFrame {...props} title={title} selectedKey={selectedKey}>
      <Card>
        <Space direction="horizontal">
          <>以文字搜尋:</>
          <Input
            placeholder="請輸入文字"
            onChange={(values) => {
              onChange(values.target.value);
            }}
          />
        </Space>
      </Card>

      <Card>
        <Spin spinning={loading}>
          <Table
            pagination={{
              defaultPageSize: 25,
              showSizeChanger: true,
              pageSizeOptions: [25, 50, 100, 200, 500]
            }}

            scroll={{ x: `max-content` }}
            dataSource={dataList}
            columns={setTableHeader()}
            rowKey={tableIdName}
          />
        </Spin>
      </Card>
      <Modal
        title={t('title.feedback')}
        visible={modalVisible}
        footer={null}
        style={{ maxWidth: 800 }}
        width="90%"
        onCancel={() => { setModalVisible(false) }}
      >
        <FeedBackForm
          selectedRecord={selectedRecord}
          openModal={(value) => {
            getAllData();
            setModalVisible(value);
          }}
        />
      </Modal>
    </NavAndSideFrame>
  );
}

export default FeedBackList;